import React, { useEffect, useState } from "react";
import useSubscribersOnlyOption from "components/Pages/Home/Helpers/useSubOnlyNotification.tsx";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useCustomController } from "../useCustomController.js";
import { setBodyValue } from "components/Pages/Home/UploadForms/formsFields.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";

import "./reusableFields.scss";

interface IPasswordFieldProps {
  textKey: string;
  icon: string;
  subcribersOnly?: boolean;
  disableOption?: string;
  getValues: () => any;
  tooltip?: string;
  clickableTooltip?: boolean;
}

const SecurityPasswordField = (props: IPasswordFieldProps) => {
  const { fieldControls, hasError } = useCustomController(props);
  const [toggleStatus, setToggleStatus] = useState(fieldControls.value);
  const [password, setPassword] = useState(fieldControls.value);
  const { getTextByKey } = useContent();

  useEffect(() => {
    fieldControls.onChange(password);
    setBodyValue(props, password);
  }, [password]);

  useEffect(() => {
    if (!toggleStatus) {
      setPassword("");
    }
  }, [toggleStatus]);

  const { SubOnlyNotification, handleSetStatus } = useSubscribersOnlyOption({
    callbackFunc: setToggleStatus,
    subcribersOnly: props.subcribersOnly || false,
    titleKey: "add-pass",
  });

  return (
    <>
      <div className="security-option column">
        <div className="row">
          {props.icon ? (
            <Icon name={props.icon} gray iconClass="security-option-icon" />
          ) : null}
          <div className="security-option-text">{getTextByKey("add-pass")}</div>
          <div className="flex-spacer" />
          <SubOnlyNotification />
          <Toggle status={toggleStatus} setStatus={handleSetStatus} />
        </div>
        {toggleStatus ? (
          <div className="password-input">
            <input
              type="text"
              name="password"
              placeholder={getTextByKey("enter-your-password-placeholder")}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default SecurityPasswordField;
